export default {
  card: {
    width: 180,
    height: 168,
    borderRadius: 2,
    position: 'relative',
    backgroundColor: 'background.grey.blue_1',
    margin: 'auto 16px 16px 16px',
  },
  outerBox: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 112,
    height: 64,
    zIndex: 1,
  },
  boxContent: {
    position: 'absolute',
    height: 120,
    bottom: 0,
    margin: 1.5,
    marginTop: 0,
    padding: 1,
    borderRadius: 2,
    backgroundColor: 'background.dark',
  },
  boxInner: {
    typography: 'h5',
    backgroundColor: 'background.grey.light',
    color: 'text.dark',
    borderRadius: 20,
    padding: '6px 12px',
    display: 'inline-flex',
    alignItems: 'center',
    mt: '20px',
    lineHeight: '16px',
  },
  editors: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: '#00AF66',
    mr: '5px',
  },
  text: {
    color: 'text.white',
    fontSize: '9px',
    fontWeight: 300,
    lineHeight: '12px',
    m: 1,
    ml: 0.5,
  },
};
